import "./vendor/url-helper-functions.js";
import "./vendor/evented-history-state-functions.js";
import "./vendor/intersection-observer.js";
import "./vendor/jquery.fancybox.js";

// Vimeo domain allowlists use the Referer header; a page-level no-referrer policy
// would otherwise strip it. Per-iframe policy ensures lightbox embeds still send origin.
(function () {
    var $ = typeof window !== "undefined" ? window.jQuery : null;
    if (!$ || !$.fancybox || !$.fancybox.defaults || !$.fancybox.defaults.iframe) {
        return;
    }
    var tpl = $.fancybox.defaults.iframe.tpl;
    if (typeof tpl !== "string" || tpl.indexOf("referrerpolicy=") !== -1) {
        return;
    }
    $.fancybox.defaults.iframe.tpl = tpl.replace("<iframe ", '<iframe referrerpolicy="origin" ');
})();
